<script>
  import { ROUTE_LOG_SCHEME, filterPermittedFields } from '../scheme'

  // 表示するカラムだけ抜き出す
  const columns = [
    {
      name: 'date',
      label: '日付',
      uneditable: true,
    },
    {
      name: 'reporterName',
      label: '報告者名',
      uneditable: true,
    },
    ...filterPermittedFields(ROUTE_LOG_SCHEME)
      // 不要なフィールドを表示しないよう省く
      .filter((field) => !['client', 'distance'].includes(field.name)),
  ]

  export let name
  export let logs = []
</script>

<table class="table">
  <!-- ヘッダ -->
  <thead>
    <tr>
      {#each columns as column}
        <th class:has-background-warning-light={column.isSecret}
          >{column.label}</th
        >
      {/each}
    </tr>
  </thead>

  <!-- ボディ -->
  <tbody>
    {#each logs as log, y}
      <tr data-testid={`${name}Log${y}`}>
        {#each columns as column, x}
          {@const value = log[column.name]}
          <td
            data-testid={`${name}Property${y}-${x}`}
            class:has-background-warning-light={column.isSecret}
            >{value ? value : ''}</td
          >
        {/each}
      </tr>
    {/each}
  </tbody>
</table>
